import { HelpMessage } from 'utils/constants'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'

export const CreateEditFormItems: React.FC = () => (
  <>
    <NameFormItem help={HelpMessage.CAS.SubTypes.Name} />
    <DescriptionFormItem entityName="Subtype" />
  </>
)
